import { CombinedFormState } from '../../../../modules/combinedForm/reducer'
import { BoxV4 } from '@labrav/react-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRuler } from '@fortawesome/pro-regular-svg-icons'

import { Typography } from '@mui/material'
import { useStyles } from './PricingView.styles'
import { InstallmentsView } from './InstallmentsView/InstallmentsView'

export type PricingViewProps = {
  disabled?: boolean
  combinedFormData: CombinedFormState | undefined
  currencySymbol: string
  viewingPersona: string
}

export default function PricingView({
  combinedFormData,
  currencySymbol,
  viewingPersona,
}: PricingViewProps) {
  const isCp = viewingPersona === 'CP'
  const { classes } = useStyles()
  return (
    <BoxV4
      style={{ padding: '32px' }}
      heading={'Pricing'}
      headingIcon={
        <FontAwesomeIcon
          icon={faRuler}
          style={{ width: '18px', height: '14px' }}
        />
      }
      variant="small"
      headingVariant="small"
    >
      <div
        style={{
          display: 'flex',
          width: '-webkit-fill-available',
          paddingTop: '20px',
          paddingBottom: '20px',
          paddingLeft: '32px',
          paddingRight: '32px',
          backgroundColor: '#F6F7F9',
          borderRadius: '4px',
        }}
      >
        <div
          style={{
            width: '33.33%',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          <Typography className={classes.sectionText}>
            Discounted TCV (to ISV)
          </Typography>
          <Typography className={classes.textClass} style={{ display: 'flex' }}>
            <span className={classes.currency}>{currencySymbol}</span>
            {combinedFormData?.resellerAgreementData.tcv}
          </Typography>
        </div>
        {isCp && (
          <>
            {' '}
            <div
              style={{
                width: '33.33%',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
              }}
            >
              <Typography className={classes.sectionText}>
                Marked-up TCV (from Buyer)
              </Typography>
              <Typography
                className={classes.textClass}
                style={{ display: 'flex' }}
              >
                {' '}
                <span className={classes.currency}>{currencySymbol}</span>
                {combinedFormData?.cppoData.tcv}
              </Typography>
            </div>
            <div
              style={{
                width: '33.33%',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
              }}
            >
              <Typography className={classes.sectionText}>
                Marked-up{' '}
              </Typography>
              <Typography className={classes.textClass}>
                {combinedFormData?.cppoData.adjustmentPercentage}%
              </Typography>
            </div>
          </>
        )}
      </div>
      <InstallmentsView
        combinedFormData={combinedFormData}
        currencySymbol={currencySymbol}
        isCp={isCp}
      />
    </BoxV4>
  )
}
